import * as types from './types';
import comments from '../queries/comments';

export const getList = ({ commit }, activePostId) => {
  comments.getList(activePostId)
    .then((response) => {
      const { data } = response;
      commit(types.SET_COMMENT_LIST, data.comments_by_post_id);
    });
};

export const create = ({ rootState, dispatch }, { comment, commentId, projectId }) => {
  const { activePost } = rootState.classIndex;

  comments.create(activePost.id, comment, commentId, projectId)
  .then(() => {
    dispatch('getList', activePost.id);
  });
};

export const remove = ({ rootState, dispatch, state }) => {
  const { activePost } = rootState.classIndex;
  const { id } = state.activeComment;

  comments.destroy(id).then(() => {
    dispatch('getList', activePost.id);
  });
};

export const setActiveComment = ({ commit }, comment) =>
  commit(types.SET_ACTIVE_COMMENT, comment);

export const resetActiveComment = ({ commit }) =>
  commit(types.RESET_ACTIVE_COMMENT);



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Comments/store/actions.js